// @owners { team: patients }
import { type ColorVariant } from '@alto/design-library-tokens';

/**
 * Icon colour for the order-summary logistics rows in checkout (date, address, delivery method,
 * refrigeration, supplies).
 *
 * On FuzeRx those rows are plain body text, so their icons take content.neutral.default (PH-4256)
 * instead of the brand green; the other brands keep the default primary icon. Kept in one place so
 * `DeliveryLogistics` and `LocationRow` — which is shared with the homescreen and order details,
 * where the icon is grey — cannot drift apart.
 */
export const getCheckoutLogisticsIconType = (): ColorVariant => 'black';
